import { getDefaultRegistry } from '@rjsf/core'
import { type IconButtonProps, type RJSFSchema, type TemplatesType } from '@rjsf/utils'
import { type ParametersFormContext } from '../formContext'
import { type JsonObject } from '../mergePatch'
import { FieldTemplate } from './FieldTemplate'
import { ArrayFieldTemplate } from './ArrayFieldTemplate'
import { AddItemLink } from './AddItemLink'
import { RemoveIconButton } from './IconButtons'
import { ObjectFieldTemplate } from './ObjectFieldTemplate'

const { ButtonTemplates: defaultButtonTemplates } = getDefaultRegistry<JsonObject, RJSFSchema, ParametersFormContext>().templates

export const parameterTemplates: Partial<TemplatesType<JsonObject, RJSFSchema, ParametersFormContext>> = {
  FieldTemplate,
  ObjectFieldTemplate,
  ArrayFieldTemplate,
  ButtonTemplates: {
    ...defaultButtonTemplates,
    AddButton: ({ className, style, disabled, onClick }: IconButtonProps<JsonObject, RJSFSchema, ParametersFormContext>) => (
      <AddItemLink noun='item' onClick={onClick} disabled={disabled} className={className} style={style} />
    ),
    RemoveButton: ({ className, style, disabled, onClick }: IconButtonProps<JsonObject, RJSFSchema, ParametersFormContext>) => (
      <RemoveIconButton onClick={onClick} disabled={disabled} className={className} style={style} />
    ),
    MoveUpButton: () => null,
    MoveDownButton: () => null,
  },
}
